module.exports = __webpack_public_path__ + "static/img/back2.bbd52b9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back2.webp
// module id = FmSs
// module chunks = 1